import { render, staticRenderFns } from "./important-links.vue?vue&type=template&id=14f83d88&scoped=true"
import script from "./important-links.vue?vue&type=script&lang=ts"
export * from "./important-links.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f83d88",
  null
  
)

export default component.exports